export enum AccessPermissionEnum {
    READ = 10,
    BASIC_MANAGE = 20,
    MANAGE = 30,
    ADMIN = 40,
    INSTALLER = 50,
    SERVICE = 60,
    PRODUCER = 70
}
